import {
  booleanAttribute,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import {
  IconComponent,
  IconSize,
} from '../../../../shared/icons/icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { DeviceValueUnit } from '@birco/rainmesh-api';
import { IconsPipe } from '../../../../shared/pipes/icons.pipe';
import { RouterLink } from '@angular/router';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { RelativeDatePipe } from '../../../../shared/pipes/relative-date.pipe';
import { PowerItemComponent } from '../power-item/power-item.component';
import { LabelConverter } from '../../../../shared/converter/label.converter';
import { DeviceResponseDto } from '../../models/device-response.interface';
import { isDeviceActive, isDevicePending } from '../../utils/device-value.utils';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';
import { TagComponent } from '../../../../shared/components/tag/tag.component';
import { DeviceActionTriggerComponent } from '../device-action-trigger/device-action-trigger.component';
import { getDeviceDetailRoute } from '../../../../shared/utils/device-route.util';

@Component({
  selector: 'app-device-item-card',
  imports: [
    CardComponent,
    IconComponent,
    TranslatePipe,
    IconsPipe,
    RouterLink,
    RelativeDatePipe,
    LocalizedNumberPipe,
    PowerItemComponent,
    LocalizedPercentPipe,
    TagComponent,
    DeviceActionTriggerComponent,
  ],
  templateUrl: './device-item-card.component.html',
  styleUrl: './device-item-card.component.scss',
})
export class DeviceItemCardComponent {
  @Input() device!: DeviceResponseDto;
  @Input() disabled: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() description?: string;
  @Input({ transform: booleanAttribute }) hideFavoriteIcon: boolean = false;
  @Output() triggerDeviceAction = new EventEmitter<{
    id: string;
    value: boolean;
  }>();

  onTriggerDeviceAction(value: boolean) {
    if (!this.device.isActuator || this.isInteractionDisabled) return;
    this.triggerDeviceAction.emit({
      id: this.device.id,
      value: value,
    });
  }

  get isPending() {
    return this.device.isActuator && isDevicePending(this.device);
  }

  get isActive() {
    return this.device.isActuator && isDeviceActive(this.device);
  }

  get isInteractionDisabled() {
    return this.disabled || this.device.isOutOfService === true;
  }

  protected readonly RouteConstants = RouteConstants;
  protected readonly getDeviceDetailRoute = getDeviceDetailRoute;
  protected readonly DeviceValueUnit = DeviceValueUnit;
  protected readonly LabelConverter = LabelConverter;
  protected readonly Number = Number;
  protected readonly IconSize = IconSize;
  protected readonly isDevicePending = isDevicePending;
}
